<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form>
                <em-filter
                  :entity="modelName"
                  query-api="receive105Query"
                  ref="emListFilter"
                  $_em-custom-vuex-mixin_vo="receive105Vo"
                  $_em-custom-vuex-mixin_filter="receive105Filter"
                  @showEntityModalSelect="
                    $_emCommonModalMixin_showModalSelectorByFilter
                  "
                ></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryItemResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <em-table
                :entity="modelName"
                query-api="receive105Query"
                withCustomRowActions
                $_em-custom-vuex-mixin_vo="receive105Vo"
                $_em-custom-vuex-mixin_filter="receive105Filter"
                ref="emTable"
                exportDisabled
                editDisable
                :inlineActionsDisabled="prop_inline !== '1'"
                @showModalSelectorByNewRow="
                  $_emCommonModalMixin_showModalSelectorByNewRow
                "
                @showModalSelectorByEditRow="
                  $_emCommonModalMixin_showModalSelectorByEditRow
                "
              >
              <template #left-header>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="handleItem()"
                  >
                    扫码收货
                </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="actionDisabled('select')"
                    @click="openBatchReceive()"
                  >
                    批量105收货
                </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="actionDisabled('selectOne')"
                    @click="openBatchReturn()"
                  >
                    106退货
                </b-button>
              </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector
      ref="emModalEntitySelector"
    ></em-modal-entity-selector>

    <el-dialog title="处理物料" :visible.sync="handleDialogVisible" :close-on-click-modal='false' append-to-body @close='clearItemList'>
      <el-table :data="itemList" height="100" empty-text="请点击打开扫码框扫码">
        <el-table-column property="materielName" label="名称"></el-table-column>
        <el-table-column property="materielUnit" label="单位"></el-table-column>
        <el-table-column property="purchaseQuantity" label="采购数量"></el-table-column>
        <el-table-column property="receivingQuantity" label="已收数量"></el-table-column>
        <el-table-column property="inspectionResult105" label="质检结果"></el-table-column>
      </el-table>

      <el-form :model="quantityForm" ref = "quantityForm" label-width="auto" style="width:20%;margin-top:15px;">
        <el-form-item label="操作数量">
            <el-input v-model="quantityForm.quantity" ></el-input>
        </el-form-item>
      </el-form>

        <el-dialog title="扫一扫" :center="true" :visible.sync="openScanner" append-to-body @close="closeScannerDialog"
                   :close-on-click-modal='false'>
        <qr-code-scanner ref="scanner" @getCodeData='getCodeData'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleDialogVisible = false">取 消</el-button> -->
        <el-button @click="openScanner = true">打开扫码框</el-button>
        <el-button type="primary" @click="confirmReceive105()" :disabled="itemList.length !== 1">收货</el-button>
        <el-button type="primary" @click="confirmReturn106()" :disabled="itemList.length !== 1">退货</el-button>
        <el-button type="primary" @click="submitExchange()" :disabled="itemList.length !== 1">换货</el-button>
        <el-button type="primary" @click="submitRepair()" :disabled="itemList.length !== 1">修货</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量105收货" :visible.sync="batchReceiveDialogVisible" :close-on-click-modal='false' append-to-body @close='clearQuantity'>
      <el-form :model="quantityForm" ref = "batchReceiveQuantityForm" label-width="auto" style="width:20%;margin-top:15px;">
        <el-form-item label="操作数量">
            <el-input v-model="quantityForm.quantity" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmReceive105('batch')">确认收货</el-button>
      </div>
    </el-dialog>

    <el-dialog title="106退货" :visible.sync="batchReturnDialogVisible" :close-on-click-modal='false' append-to-body @close='clearQuantity'>
      <el-form :model="quantityForm" ref = "batchReturnQuantityForm" label-width="auto" style="width:20%;margin-top:15px;">
        <el-form-item label="操作数量">
            <el-input v-model="quantityForm.quantity" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmReturn106('batch')">确认退货</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
// Author Lin
// Date 2021-04-21 11:22:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"

export default {
  name: "sithMesInventoryItemListView",
  components: { qrCodeScanner },
  mixins: [emCommonListMixin,emCommonApiMixin,qrCodeScanner],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      handleDialogVisible: false,
      openScanner: false,
      itemList: [],
      quantityForm: {
        quantity:""
      },
      batchReceiveDialogVisible: false,
      batchReturnDialogVisible: false,
    }
  },
  computed: {
    modelName() {
      return "sithMesInventoryItem"
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItemsReceive103Vo"];
      // return this.$refs.emTable.checkedItems
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItemsReceive103Vo"].join(",");
    },
  },
  methods: {
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    handleItem() {
      this.handleDialogVisible = true;
    },
    clearItemList() {
      this.itemList = [];
      this.quantityForm.quantity = '';
    },
    closeScannerDialog() {
      this.$refs.scanner.closeCamera();
      this.$refs.scanner.resetOutputData();
      this.openScanner = false;
    },
    getCodeData(data) {
      console.log("get qr code data:"+data);
      this.openScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }
      //是否可以直接在this.$store.state[this.modelName].receive101Vo中查找扫描到的物料，从而可以不用调后端接口检验物料状态？
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/`;
      _url += `checkIfInspectionFinished?poNumber=${poNumber}&item=${item}`;
      this.$_emApiMixin_get(_url, {})
        .then((value) => {
          var arr = Object.keys(value);
          if (arr.length != 0) {
            console.log("value======"+JSON.stringify(value));
            self.itemList = [];
            self.itemList.push(value);
            self.$message({
              message: "扫码成功",
              type: "success",
            });
          } else {
            self.$message({
              message: "无对应物料或物料尚未质检",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.openScanner = false;
        });
    },
    confirmReceive105(type) {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/confirmReceive105`;
      let requestBody = {};
      let ids;
      if(type === 'batch') {
        ids = self.selectIds;
      } else{
        ids = self.itemList.map(obj => {return obj.id}).join(",");
      }
      requestBody.idStr = ids;
      requestBody.receiveQuantity = self.quantityForm.quantity;
      self.$_emApiMixin_post(_url, requestBody)
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "确认收货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "确认收货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.handleDialogVisible = false;
          this.batchReceiveDialogVisible = false;
        });
    },
    confirmReturn106(type) {
      let self = this;
      let itemId;
      if(type === 'batch') {
        itemId = self.selectIds;
      } else {
        itemId = self.itemList[0].id;
      }
      let returnQuantity = self.quantityForm.quantity;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/confirmReturn106?poItemId=${itemId}&returnQuantityStr=${returnQuantity}`;
      self.$_emApiMixin_post(_url, {})
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "106退货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "106退货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.handleDialogVisible = false;
          this.batchReturnDialogVisible = false;
        });
    },
    openBatchReceive() {
      this.batchReceiveDialogVisible = true;
    },
    clearQuantity() {
      this.quantityForm.quantity = '';
    },
    openBatchReturn() {
      this.batchReturnDialogVisible = true;
    }
  }
};
</script>
